export default __webpack_public_path__ + "static/media/info.3f1ac978.svg";